import React from "react";

const ClientDetailPageSkeleton = () => {
  return (
    <div className="animate-pulse px-4 sm:px-6 lg:px-8">
      {/* Back button */}
      <div className="h-8 w-24 bg-cream-300 rounded mb-6"></div>
      {/* Client info */}
      <div className="flex items-center gap-6 mb-8">
        <div className="size-20 bg-cream-300 rounded-full"></div>
        <div className="flex-1">
          <div className="h-5 bg-cream-300 rounded w-40 mb-2"></div>
          <div className="h-4 bg-cream-300 rounded w-32 mb-1"></div>
          <div className="h-4 bg-cream-300 rounded w-48"></div>
        </div>
        <div className="flex gap-2">
          <div className="h-8 w-20 bg-cream-300 rounded"></div>
          <div className="h-8 w-20 bg-cream-300 rounded"></div>
        </div>
      </div>
      {/* Appointments section */}
      <div className="mb-8">
        <div className="h-5 bg-cream-300 rounded w-32 mb-4"></div>
        {[1, 2, 3].map((i) => (
          <div key={i} className="flex items-center gap-4 mb-4">
            <div className="h-10 w-10 bg-cream-300 rounded-full"></div>
            <div className="flex-1">
              <div className="h-4 bg-cream-300 rounded w-32 mb-1"></div>
              <div className="h-3 bg-cream-300 rounded w-48"></div>
            </div>
            <div className="h-8 w-20 bg-cream-300 rounded"></div>
          </div>
        ))}
      </div>
      {/* Pagination */}
      <div className="flex justify-end mt-4 gap-2">
        {[1, 2, 3, 4, 5].map((i) => (
          <div key={i} className="h-6 w-6 bg-cream-300 rounded-full"></div>
        ))}
      </div>
    </div>
  );
};

export default ClientDetailPageSkeleton;
